import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { BD, brancheData, defaultBrancheData } from '../data/branchen';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

function BranchePage() {
  const { key } = useParams();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const d = BD.find(b => b.key === key);
  if (!d) {
    return (
      <>
        <Nav />
        <div style={{padding:'120px 40px',textAlign:'center'}}>
          <h1 style={{fontSize:32,fontWeight:800,color:'#111',marginBottom:16}}>Branche nicht gefunden</h1>
          <button className="btn-hero-p" onClick={() => navigate('/')}>Zur Startseite</button>
        </div>
        <Footer simple />
      </>
    );
  }

  const bd = brancheData[key] || defaultBrancheData;
  const stats = bd.stats;
  const similar = BD.filter(b => b.key !== key).slice(0, 4);
  const sidebarItems = BD.slice(0, 12);
  const px = isMobile ? '20px' : '40px';

  return (
    <>
      <Nav />

      {/* HERO MIT BILD */}
      <div style={{position:'relative',minHeight: isMobile ? 420 : 480,overflow:'hidden'}}>
        <img src={d.img} alt={d.name} style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',filter:'brightness(.45)'}} />
        <div style={{position:'absolute',inset:0,background: isMobile ? 'rgba(0,0,0,.75)' : 'linear-gradient(to right, rgba(0,0,0,.85) 50%, transparent 100%)'}} />
        <div style={{position:'relative',zIndex:2,maxWidth:1280,margin:'0 auto',padding: isMobile ? '80px 20px 48px' : '100px 40px 72px'}}>
          {!isMobile && (
            <div style={{fontSize:12,color:'rgba(255,255,255,.4)',marginBottom:16,display:'flex',alignItems:'center',gap:8}}>
              <span onClick={() => navigate('/')} style={{cursor:'pointer'}} >Home</span>
              <span style={{opacity:.3}}>/</span>
              <span onClick={() => navigate('/', {state:{scrollTo:'branchen'}})} style={{cursor:'pointer'}}>Branchen</span>
              <span style={{opacity:.3}}>/</span>
              <span style={{color:'rgba(255,255,255,.7)',fontWeight:600}}>{d.name}</span>
            </div>
          )}

          <div style={{display:'inline-flex',alignItems:'center',gap:6,background:'rgba(255,255,255,.1)',color:'#fff',padding:'6px 14px',borderRadius:8,fontSize:13,fontWeight:600,marginBottom:18,border:'1px solid rgba(255,255,255,.15)',backdropFilter:'blur(8px)'}}>
            {d.name}
          </div>

          <h1 style={{fontSize: isMobile ? 'clamp(32px,8vw,48px)' : 'clamp(44px,5.5vw,72px)',fontWeight:800,letterSpacing:'-2px',lineHeight:1.06,color:'#fff',marginBottom:16,maxWidth:700}}>
            FrontUp für {d.name}.
          </h1>
          <p style={{fontSize: isMobile ? 15 : 18,color:'rgba(255,255,255,.55)',lineHeight:1.7,maxWidth:560,marginBottom:32}}>
            Kein Anruf geht mehr verloren – FrontUp übernimmt Telefonie, Terminbuchung und Kundenanfragen für {d.name} vollautomatisch.
          </p>
          <div style={{display:'flex',flexDirection: isMobile ? 'column' : 'row',gap:12}}>
            <button onClick={() => navigate('/preise')} style={{padding:'14px 28px',background:'#fff',color:'#111',border:'none',borderRadius:8,fontSize:15,fontWeight:700,fontFamily:'inherit',cursor:'pointer'}}>Ersparnis berechnen</button>
            <button onClick={() => navigate('/', {state:{scrollTo:'demo'}})} style={{padding:'13px 28px',background:'transparent',color:'rgba(255,255,255,.7)',border:'1.5px solid rgba(255,255,255,.25)',borderRadius:8,fontSize:15,fontWeight:600,fontFamily:'inherit',cursor:'pointer'}}>Demo anrufen lassen</button>
          </div>
        </div>
      </div>

      {/* STATS STRIP */}
      <div style={{borderBottom:'1px solid var(--border)'}}>
        <div style={{maxWidth:1280,margin:'0 auto',display:'grid',gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)'}}>
          {[0,2,4].map((i, idx) => (
            <div key={i} style={{
              padding: isMobile ? '20px 20px' : '32px 40px',
              borderRight: !isMobile && idx < 2 ? '1px solid var(--border)' : 'none',
              borderBottom: isMobile && idx < 2 ? '1px solid var(--border)' : 'none',
              display:'flex',alignItems:'center',gap:16
            }}>
              <div style={{fontSize: isMobile ? 32 : 40,fontWeight:800,letterSpacing:'-2px',color:'#111',lineHeight:1}}>{stats[i]}</div>
              <div style={{fontSize:14,color:'#888',lineHeight:1.5}}>{stats[i+1]}</div>
            </div>
          ))}
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div style={{maxWidth:1280,margin:'0 auto',padding: isMobile ? '40px 20px' : '72px 40px'}}>
        <div style={{display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 320px',gap: isMobile ? 40 : 64,alignItems:'start'}}>

          {/* BODY */}
          <div>
            {/* AUFGABEN */}
            <div style={{marginBottom: isMobile ? 40 : 56}}>
              <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#111',marginBottom:14}}>Was FrontUp übernimmt</div>
              <h2 style={{fontSize: isMobile ? 'clamp(22px,6vw,32px)' : 'clamp(28px,3.5vw,40px)',fontWeight:800,letterSpacing:'-1.5px',lineHeight:1.08,color:'#111',marginBottom:32}}>
                Was {d.name} mit FrontUp automatisieren.
              </h2>
              <div style={{display:'flex',flexDirection:'column',gap:0,border:'1.5px solid var(--border)',borderRadius:14,overflow:'hidden'}}>
                {bd.aufgaben.map((a, i) => (
                  <div key={i} style={{padding: isMobile ? '16px 18px' : '18px 24px',borderTop: i>0 ? '1px solid var(--border)' : 'none',display:'flex',alignItems:'center',gap:16}}>
                    <div style={{width:28,height:28,background:'#111',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:800,color:'#fff',flexShrink:0}}>{i+1}</div>
                    <div style={{fontSize: isMobile ? 14 : 15,color:'#333',fontWeight:500}}>{a}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* CTA CARD — nur auf Mobile hier eingebettet */}
            {isMobile && (
              <div style={{background:'#111',borderRadius:14,padding:24,marginBottom:40}}>
                <div style={{fontSize:17,fontWeight:700,color:'#fff',marginBottom:6}}>Jetzt testen</div>
                <div style={{fontSize:13,color:'rgba(255,255,255,.4)',marginBottom:18,lineHeight:1.5}}>KI ruft dich in 30 Sekunden an – kostenlos & unverbindlich.</div>
                <button onClick={() => navigate('/', {state:{scrollTo:'demo'}})} style={{display:'block',width:'100%',padding:13,background:'#fff',color:'#111',border:'none',borderRadius:8,fontFamily:'inherit',fontSize:14,fontWeight:700,cursor:'pointer',marginBottom:8}}>Demo starten</button>
              </div>
            )}

            {/* SZENARIEN */}
            <div style={{marginBottom: isMobile ? 40 : 56}}>
              <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#111',marginBottom:14}}>So sieht es in der Praxis aus</div>
              <h2 style={{fontSize: isMobile ? 'clamp(20px,5vw,28px)' : 'clamp(24px,3vw,36px)',fontWeight:800,letterSpacing:'-1px',lineHeight:1.1,color:'#111',marginBottom:28}}>Drei Alltagssituationen.</h2>
              <div style={{display:'flex',flexDirection:'column',gap:0}}>
                {bd.szenarien.map((s, i) => (
                  <div key={i} style={{padding: isMobile ? '20px 0' : '28px 0',borderTop: i>0 ? '1px solid var(--border)' : 'none',display:'grid',gridTemplateColumns:'40px 1fr',gap: isMobile ? 16 : 24,alignItems:'start'}}>
                    <div style={{width:40,height:40,background:'#111',borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:800,color:'#fff',flexShrink:0}}>
                      {i < 9 ? `0${i+1}` : i+1}
                    </div>
                    <div>
                      <div style={{fontSize: isMobile ? 15 : 16,fontWeight:700,color:'#111',marginBottom:6}}>{s[1]}</div>
                      <div style={{fontSize: isMobile ? 14 : 15,color:'#666',lineHeight:1.75}}>{s[2]}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* VORTEILE */}
            <div style={{background:'#111',borderRadius:16,padding: isMobile ? 24 : 44}}>
              <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'rgba(255,255,255,.3)',marginBottom:14}}>Das Ergebnis</div>
              <h2 style={{fontSize: isMobile ? 'clamp(20px,5vw,28px)' : 'clamp(24px,3vw,36px)',fontWeight:800,letterSpacing:'-1px',color:'#fff',marginBottom:28}}>{bd.result}</h2>
              <div style={{display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap:12}}>
                {bd.vorteile.map((v, i) => (
                  <div key={i} style={{background:'rgba(255,255,255,.07)',border:'1px solid rgba(255,255,255,.1)',borderRadius:10,padding:'14px 18px',display:'flex',alignItems:'center',gap:12}}>
                    <div style={{width:20,height:20,background:'rgba(255,255,255,.15)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:800,color:'#fff',flexShrink:0}}>✓</div>
                    <div style={{fontSize:14,color:'rgba(255,255,255,.8)',fontWeight:500}}>{v}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* SIDEBAR — nur Desktop */}
          {!isMobile && (
            <div style={{position:'sticky',top:80}}>
              <div style={{background:'#111',borderRadius:14,padding:28,marginBottom:14}}>
                <div style={{fontSize:17,fontWeight:700,color:'#fff',marginBottom:6}}>Jetzt testen</div>
                <div style={{fontSize:13,color:'rgba(255,255,255,.4)',marginBottom:18,lineHeight:1.5}}>KI ruft dich in 30 Sekunden an – kostenlos & unverbindlich.</div>
                <button onClick={() => navigate('/', {state:{scrollTo:'demo'}})} style={{display:'block',width:'100%',padding:12,background:'#fff',color:'#111',border:'none',borderRadius:8,fontFamily:'inherit',fontSize:13,fontWeight:700,cursor:'pointer',marginBottom:8}}>Demo starten</button>
                </div>

              <div style={{background:'#fff',border:'1.5px solid var(--border)',borderRadius:14,padding:20}}>
                <div style={{fontSize:11,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#aaa',marginBottom:16,paddingBottom:12,borderBottom:'1px solid var(--border)'}}>Alle Branchen</div>
                <ul style={{listStyle:'none',display:'flex',flexDirection:'column',gap:1}}>
                  {sidebarItems.map(b => (
                    <li key={b.key} onClick={() => navigate('/branche/' + b.key)} className={`sn-link${b.key === key ? ' active' : ''}`}>
                      {b.name}
                      {b.key === key && (
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.5)" strokeWidth="2.5">
                          <polyline points="9 18 15 12 9 6"/>
                        </svg>
                      )}
                    </li>
                  ))}
                </ul>
                <div style={{marginTop:14,paddingTop:14,borderTop:'1px solid var(--border)'}}>
                  <button onClick={() => navigate('/', {state:{scrollTo:'branchen'}})} style={{width:'100%',padding:10,background:'#f7f7f7',border:'1px solid var(--border)',borderRadius:8,fontFamily:'inherit',fontSize:13,fontWeight:600,color:'#555',cursor:'pointer'}}>Alle Branchen ansehen →</button>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>

      {/* ÄHNLICHE BRANCHEN */}
      <section style={{background:'#f7f7f7',padding: isMobile ? '48px 20px' : '72px 40px',borderTop:'1px solid var(--border)'}}>
        <div style={{maxWidth:1280,margin:'0 auto'}}>
          <h2 style={{fontSize: isMobile ? 'clamp(20px,5vw,28px)' : 'clamp(24px,3vw,36px)',fontWeight:800,letterSpacing:'-1px',color:'#111',marginBottom:24}}>Ähnliche Branchen</h2>
          <div style={{display:'grid',gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)',gap: isMobile ? 10 : 14}}>
            {similar.map(b => (
              <div
                key={b.key}
                onClick={() => navigate('/branche/' + b.key)}
                style={{background:'#fff',border:'1.5px solid var(--border)',borderRadius:12,overflow:'hidden',cursor:'pointer'}}
              >
                <img src={b.img} style={{width:'100%',height: isMobile ? 100 : 140,objectFit:'cover',display:'block',filter:'brightness(.8)'}} alt={b.name} />
                <div style={{padding: isMobile ? '10px 12px' : '14px 16px'}}>
                  <div style={{fontSize:13,fontWeight:700,color:'#111',marginBottom:3}}>{b.name}</div>
                  {!isMobile && <div style={{fontSize:12,color:'#aaa'}}>{b.desc}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer simple />
    </>
  );
}

export default BranchePage;
